// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Slide from "@material-ui/core/Slide";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { iconStyles } from "../../styles/iconStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  root: {
    lineHeight: "24px",
    verticalAlign: "top"
  },
  rightMargin: {
    marginRight: "5px"
  }
});

type SnackbarMessageClassesType = {
  ...IconStylesClassesType,
  root: DictionaryType,
  rightMargin: DictionaryType
};

type SnackbarMessagePropsType = {
  classes: SnackbarMessageClassesType,
  message: string,
  open: boolean,
  handleModalStatus: Function
};

function TransitionDown(props: SnackbarMessagePropsType): React$Element<*> {
  return <Slide direction="down" {...props} />;
}

class SnackbarMessage extends Component<SnackbarMessagePropsType, *> {
  handleOpen = () => {
    this.props.handleModalStatus(true);
  };

  handleClose = () => {
    this.props.handleModalStatus(false);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <Snackbar
        open={this.props.open}
        onClose={this.handleClose}
        TransitionComponent={TransitionDown}
        autoHideDuration={5000}
        ContentProps={{
          "aria-describedby": "message-id"
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <SnackbarContent
          message={
            <span id="message-id" className={classes.root}>
              <CheckCircleIcon
                className={classNames(classes.rightMargin, classes.shineIcon)}
              />
              {this.props.message}
            </span>
          }
        />
      </Snackbar>
    );
  }
}

export default withStyles(styles)(SnackbarMessage);
